export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const getQueryParam = (url, param) => {
  const params = url.split("?")[1];
  const urlSearchParams = new URLSearchParams(params);
  return urlSearchParams.get(param);
};
